export default (client) => ({
  post(payload) {
    return client.request({
      method: 'post',
      url: '/roles',
      data: payload,
    });
  },
});
